import styles from '../Interview.module.scss'

type Props = {
  texts: (string | JSX.Element)[]
  wide?: boolean
  bold?: boolean
}

const TextBox: React.FC<Props> = ({ texts, wide, bold }) => {
  return (
    <div
      className={`${styles.text_box} ${wide ? styles.text_box__wide : ''} ${bold ? styles.text_box__bold : ''}`}
    >
      {texts.map((text, index) => (
        <p key={index}>{typeof text === 'string' ? text : text}</p>
      ))}
    </div>
  )
}

export default TextBox
